import { render, staticRenderFns } from "./EventDetailPage.vue?vue&type=template&id=3b921bf8&scoped=true"
import script from "./EventDetailPage.vue?vue&type=script&lang=js"
export * from "./EventDetailPage.vue?vue&type=script&lang=js"
import style0 from "./EventDetailPage.vue?vue&type=style&index=0&id=3b921bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b921bf8",
  null
  
)

export default component.exports